export const SAVE_SUPPORT_TICKET = "SAVE_SUPPORT_TICKET";
export const GET_ALL_SUPPORT_TICKET = "GET_ALL_SUPPORT_TICKET"